import { render } from "./Bubbles.vue?vue&type=template&id=69592f4c&scoped=true&ts=true"
import script from "./Bubbles.vue?vue&type=script&lang=ts"
export * from "./Bubbles.vue?vue&type=script&lang=ts"

import "./Bubbles.vue?vue&type=style&index=0&id=69592f4c&lang=scss&scoped=true"

import exportComponent from "/var/www/widget.surveybot.me/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69592f4c"]])

export default __exports__